import { render, staticRenderFns } from "./new-root-region-form.vue?vue&type=template&id=184e338b&"
import script from "./new-root-region-form.vue?vue&type=script&lang=js&"
export * from "./new-root-region-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports